import { Tag, TagProps, styled } from '@cad-arc';

const StyledLinkedEventNumber = styled(Tag)<{ $isInteractive: boolean }>`
    color: var(--arc-colors-brand-default);
    background: var(--arc-colors-brand-accent);
    /* width: fit-content; */
    cursor: ${(props) => (props.$isInteractive ? 'pointer' : 'default')};
`;

type LinkedEventNumberProps = TagProps & {
    onClick?: () => void;
};

/** ARC Tags are not specifically interactive by default.
 * Some of this could be removed if we update the ARC tag to be interactive and act like a button. */
export const LinkedEventNumber = ({
    onClick,
    ...props
}: LinkedEventNumberProps): React.ReactElement => {
    function handleKeyDown(e: React.KeyboardEvent): void {
        if (e.code === 'Enter' || e.code === 'Space') {
            if (onClick) {
                onClick();
            }
        }
    }
    return (
        <StyledLinkedEventNumber
            data-testid="linked-event-number"
            size="sm"
            $isInteractive={onClick ? true : false}
            tabIndex={onClick ? 0 : undefined}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            {...props}
        />
    );
};
